// extracted by mini-css-extract-plugin
export var actions = "_hx-g";
export var benefitCard = "_hx-b";
export var benefitIcon = "_hx-d";
export var benefitLabel = "_hx-f";
export var benefits = "_hx-a";
export var benefitsSection = "_hx-8";
export var bodyText = "_hx-7";
export var closeButton = "_hx-2";
export var content = "_hx-3";
export var eyebrow = "_hx-4";
export var heading = "_hx-5";
export var image = "_hx-i";
export var imagePanel = "_hx-h";
export var modal = "_hx-0";
export var offerCard = "_hx-c";
export var offerIcon = "_hx-e";
export var sectionLabel = "_hx-9";
export var shell = "_hx-1";
export var title = "_hx-6";